<ng-container *ngIf="route!=null">

    <shared-general-status-viewer [generalStatus]="route.generalStatus"
        class="in-bottom-zone"></shared-general-status-viewer>

    <ng-container *ngIf="slotsInfo && slotsInfo.length > 0">
        <shared-slot-viewer-component *ngFor="let slotInfo of slotsInfo | sortBy" class="lineItem showDock relative"
            [slotInfo]="slotInfo">
        </shared-slot-viewer-component>
    </ng-container>
    <div class="icona banned element only-phoneBanned" [ngClass]="generalClass">
        <i class="fa fa-user " aria-hidden="true"></i>
    </div>
    <div class="icona banned element only-plateBanned" [ngClass]="generalClass">
        <i class="fa fa-truck " aria-hidden="true"></i>
    </div>
    <!-- REQUADRES -->
    <!-- PARTNERS -->
    <div *ngIf="route.partnerParentTrademark" class="partner requadre parent element"
        [style.color]="getColor(route.partnerParentTrademark)"
        [style.background-color]="getBackgroundColor(route.partnerParentTrademark)">
        <span class="trademark">{{ route.partnerParentTrademark }}</span>
    </div>
    <div *ngIf="route.partnerShipperId && route.partnerShipperTrademark && (route.partnerParentTrademark!=route.partnerShipperTrademark)"
        class="partner requadre shipper element">
        <span class="trademark">{{ route.partnerShipperTrademark }}</span>
    </div>
    <div *ngIf="route.partnerCarrierId && route.partnerCarrierTrademark && (route.partnerParentTrademark!=route.partnerCarrierTrademark)"
        class="partner requadre carrier element">
        <span class="trademark">{{ route.partnerCarrierTrademark }}</span>
    </div>
    <div *ngIf="route.partnerLogisticOperatorId && route.partnerLogisticOperatorTrademark"
        class="partner requadre logistic-operator element"><span class="trademark">{{
            route.partnerLogisticOperatorTrademark
            }}</span></div>
    <div *ngIf="route.partnerDriverId && route.partnerDriverTrademark" class="partner requadre driver element">
        <span class="trademark">{{ route.partnerDriverTrademark }}</span>
    </div>
    <div *ngIf="route.partnerSecondDriverId && route.partnerSecondDriverTrademark"
        class="partner requadre driver element">
        <span class="trademark">{{ route.partnerSecondDriverTrademark }}</span>
    </div>
    <div *ngIf="route.partnerInspectorId && route.partnerInspectorTrademark" class="partner requadre inspector element">
        <span class="trademark">{{ route.partnerInspectorTrademark }}</span>
    </div>
    <div *ngIf="route.partnerClientPreferentId && route.partnerClientPreferentTrademark"
        class="partner requadre client element">
        <span class="trademark">{{ route.partnerClientPreferentTrademark }}</span>
    </div>
    <!-- LABEL ENTREGUES -->
    <div *ngIf="!isActiveRoutes" class="partner requadre deliveries-label element"
        [ngClass]="{'withslot':showAssignedSlots,'show': !isActiveRoutes && route.isDivided && route.childs != null }">
        <span class="deliveries-label-text"> {{ 'ROUTEPAGE.ITEM.DIVIDED.HASCHILDS' | translate
            :{childsNumber:getChildsNumber(route)} }}</span>
    </div>

    <!-- MARGE DE TEMPS PER RESERVA DE SLOT -->
    <div *ngIf="route.hasSlotReserveMarginTime" class="partner requadre slot-reserve-margin-time">
        {{ route.slotReserveMarginTime | time }}
    </div>
    <!-- TIPOLOGIA -->
    <div *ngIf="route.typology" class="partner requadre typology element">
        {{ route.typology }}
    </div>
    <!-- EXWORK -->
    <div *ngIf="route.isExwork" class="partner requadre exwork element link">
        <a class="white" (click)="goToExwork(route)">
            {{
            'ROUTE.EXWORK.CAPTION'
            | translate }}
        </a>
    </div>
    <div *ngIf="route.incoterm && route.incoterm!='none' && route.incoterm!='EXW'"
        class="partner requadre typology element">
        {{route.incoterm}}
    </div>


    <!-- ICONES -->
    <!-- BOOKING -->
    <div *ngIf="route.bookingSlotId" class="icona booking element clickable" (click)="goToBooking()"><i
            class="fa fa-ship"></i>
    </div>
    <!-- CERTIFICAT -->
    <div *ngIf="route.requiredCertificate" class="icona required-certificate element"><i
            class="hardman-certificate"></i></div>
    <!-- INSPECTOR -->
    <div *ngIf="route.requiredInspector" class="icona required-inspector element"><i class="hardman-inspector"></i>
    </div>
    <!-- AGRUPADA -->
    <div *ngIf="route.isGrouped" class="icona grouped element"><i class="fa fa-compress"></i>
        <div class="group-size">{{route.groupCount}}</div>
    </div>
    <!-- FILLA AGRUPADA -->
    <div *ngIf="route.isChildOfGrouped" class="icona grouped element"><i class="fa fa-expand"></i></div>
    <!-- RUTA TRANCADA PER CAMIONITZAR -->
    <div *ngIf="route.isBrokenForTrucking" class="icona brokentrucking element"><i class="fa fa-chain-broken"></i>
    </div>
    <!-- RUTA CAMIONITZADA PENDENT DE CONFIRMAR -->
    <div *ngIf="route.isTrucked" class="icona trucked element"
        [ngClass]="{'pendingconfirmed' : !route.truckingConfirmed}"><i class="fa fa-truck"></i></div>
    <!-- BANNER HTML -->
    <div *ngIf="route.hasBannerHtml || route.bannerHtml || route.privateBannerHtml" class="icona bell element"><i
            class="fa fa-bell" aria-hidden="true"></i></div>

    <!-- Icones custom -->
    <div *ngIf="route.icons && route.icons.length > 0">
        <div *ngFor="let icona of route.icons" class="icona element">
            <i *ngIf="icona.family == 'fontawesome'" class="{{ icona.icon }}"></i>
            <mat-icon *ngIf="icona.family == 'material'">{{ icona.icon }}</mat-icon>
        </div>
    </div>

    <!-- TIPOLOGIES DE RUTA -->
    <img *ngIf="route.isInbound" class="icona element" src="/assets/images/routetype-inbound.svg" alt="Inbound">
    <img *ngIf="route.isNonacceptance" class="icona element" src="/assets/images/routetype-nonacceptance.svg"
        alt="Non acceptance">
    <img *ngIf="route.isReturn" class="icona element" src="/assets/images/routetype-return.svg" alt="Return">
    <img *ngIf="route.isReverseLogistics" class="icona element" src="/assets/images/logisticaInversa.svg"
        alt="Reverse logistics">
    <img *ngIf="route.isOutbound" class="icona element" src="/assets/images/routetype-outbound.svg" alt="Outbound">
    <img *ngIf="route.isDelegate" class="icona element" src="/assets/images/routetype-delegate.svg" alt="Delegate">


    <!-- EN RETRÀS -->
    <i class="icona isdelayed fa fa-clock-o element" aria-hidden="true" *ngIf="route.isDelayed"></i>

    <!-- SÓC OBSERVADOR -->
    <i class="iamobserver fa fa-eye element" aria-hidden="true" *ngIf="route.iAmObserver"></i>

    <routephase-timeline class="onHeader" [route]="route"></routephase-timeline>
</ng-container>

<ng-container *ngIf="phaseslot!=null">
    <shared-slot-viewer-component *ngIf="slotInfoPhase" class="relative element showDock" [slotInfo]="slotInfoPhase"
        [phaseId]="loadConsoleSlotPhase ? loadConsoleSlotPhase.phaseId : phaseslot.phaseId"
        [lostSlotId]="loadConsoleSlotPhase && loadConsoleSlotPhase.showLostSlotWhenReachedLate ? loadConsoleSlotPhase.lostSlotId : null"
        (callBack)="onCallBack($event)">
    </shared-slot-viewer-component>
    <div class="icona banned element only-phoneBanned" [ngClass]="generalClass">
        <i class="fa fa-user " aria-hidden="true"></i>
    </div>
    <div class="icona banned element only-plateBanned" [ngClass]="generalClass">
        <i class="fa fa-truck " aria-hidden="true"></i>
    </div>

    <div *ngIf="phaseslot.partnerParentTrademark" class="partner requadre parent element"
        [style.color]="getColor(phaseslot.partnerParentTrademark)"
        [style.background-color]="getBackgroundColor(phaseslot.partnerParentTrademark)">
        <span class="trademark ellipsis">{{ phaseslot.partnerParentTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerShipperId && phaseslot.partnerShipperTrademark && (phaseslot.partnerParentTrademark!=phaseslot.partnerShipperTrademark)"
        class="partner requadre shipper element">
        <span class="trademark ellipsis">{{ phaseslot.partnerShipperTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerCarrierId && phaseslot.partnerCarrierTrademark && (phaseslot.partnerParentTrademark!=phaseslot.partnerCarrierTrademark)"
        class="partner requadre carrier element">
        <span class="trademark ellipsis">{{ phaseslot.partnerCarrierTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerLogisticOperatorId && phaseslot.partnerLogisticOperatorTrademark"
        class="partner requadre logistic-operator element"><span class="trademark ellipsis">{{
            phaseslot.partnerLogisticOperatorTrademark
            }}</span></div>
    <div *ngIf="phaseslot.partnerDriverId && phaseslot.partnerDriverTrademark" class="partner requadre driver element">
        <span class="trademark ellipsis">{{ phaseslot.partnerDriverTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerSecondDriverId && phaseslot.partnerSecondDriverTrademark"
        class="partner requadre driver element">
        <span class="trademark ellipsis">{{ phaseslot.partnerSecondDriverTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerInspectorId && phaseslot.partnerInspectorTrademark"
        class="partner requadre inspector element">
        <span class="trademark ellipsis">{{ phaseslot.partnerInspectorTrademark }}</span>
    </div>
    <div *ngIf="phaseslot.partnerClientPreferentId && phaseslot.partnerClientPreferentTrademark"
        class="partner requadre client element">
        <span class="trademark ellipsis">{{ phaseslot.partnerClientPreferentTrademark }}</span>
    </div>

    <div *ngIf="phaseslot.typology" class="partner requadre typology element">
        {{ phaseslot.typology }}
    </div>
    <!-- AGRUPADA -->
    <div *ngIf="phaseslot.isGrouped" class="icona grouped element"><i class="fa fa-compress"></i>
        <div class="group-size">{{phaseslot.groupCount}}</div>
    </div>
    <!-- FILLA AGRUPADA -->
    <div *ngIf="phaseslot.isChildOfGrouped" class="icona grouped element"><i class="fa fa-expand"></i></div>

    <!-- TIPUS DE RUTA -->
    <img class="icona element" *ngIf="phaseslot.isInbound" src="/assets/images/routetype-inbound.svg" alt="Inbound">
    <img class="icona element" *ngIf="phaseslot.isReturn" src="/assets/images/routetype-return.svg" alt="Return">
    <img class="icona element" *ngIf="phaseslot.isReverseLogistics" src="/assets/images/logisticaInversa.svg"
        alt="Reverse logistics">
    <img class="icona element" *ngIf="phaseslot.isNonacceptance" src="/assets/images/routetype-nonacceptance.svg"
        alt="Nonacceptance">
    <img class="icona element" *ngIf="phaseslot.isOutbound" src="/assets/images/routetype-outbound.svg" alt="Outbound">
    <img class="icona element" *ngIf="phaseslot.isDelegate" src="/assets/images/routetype-delegate.svg" alt="Delegate">
    <!-- BANNER HTML -->
    <div *ngIf="phaseslot.hasBannerHtml" class="icona bell"><i class="fa fa-bell" aria-hidden="true"></i></div>

    <routephase-timeline [contadors]="phaseslot" class="onHeader"></routephase-timeline>
</ng-container>